
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Namespace } from 'enums/namespaces';
import { basicSEO, Permalink } from 'helpers';
import useTranslation from 'next-translate/useTranslation';
import Layout from '../../components/Layout';
import Head from 'next/head';
import styles from './index.module.scss';
import AppLink from 'components/AppLink/AppLink';
import { useLang } from 'context/langContext';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { StaticPathParams } from 'typings/staticPaths';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { useCallback, useMemo } from 'react';

interface Props {
  hideHeaderAndFooter?: boolean;
  hideLinks?: boolean;
  countryCode: string;
  forceLocale?: string;
}

const TermsAndCondtions = ({
  hideHeaderAndFooter = false,
  hideLinks = false,
  countryCode,
  forceLocale,
}: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.Common);
  const { locale: _locale } = useLang();

  const locale = useMemo(() => {
    return forceLocale ?? _locale;
  }, [_locale, forceLocale]);

  const csTerms = () => {
    return (
      <>
        <p className={styles.updated}>Aktualizováno 26.11.2020</p>
        <h1>Obchodní podmínky</h1>
        <h2>Obecná ustanovení</h2>
        <ul>
          <li>
            Společnost Dramox s.r.o., se sídlem na adrese Bucharova 2928/14a, Stodůlky, 158 00 Praha 5, Aspira Business
            Centre, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 332337
            (&bdquo;Dramox&ldquo;), poskytuje audiovizuální mediální služby na vyžádání s&nbsp;názvem Dramox na adrese
            dramox.cz nebo v aplikaci vytvořené společností Dramox (dále jen &bdquo;Stránky&ldquo;) s obsahem dostupným
            na vyžádání v&nbsp;prostředí Internetu (&bdquo;Služba&ldquo;).
          </li>
          <li>
            Všeobecné obchodní podmínky se použijí na smlouvy o poskytování Služby mezi Dramoxem a uživatelem jako
            fyzickou osobou (&bdquo;Uživatel&ldquo;) a mezi Dramoxem a podnikatelskými subjekty a/nebo veřejnoprávními
            institucemi jako jsou školská a sociální zařízení. Smlouvu o poskytování Služby mohou s Dramoxem uzavřít
            osoby starší 18 let s trvalým bydlištěm na území České republiky, osoby mladší 18 let pouze prostřednictvím
            svých zákonných zástupců. Dramox je oprávněn odmítnout uzavření smlouvy s Uživatelem, nebo smlouvu s
            Uživatelem s okamžitou platností ukončit, pokud Uživatel porušuje tyto obchodní podmínky.
          </li>
          <li>
            Tyto Obchodní podmínky jsou pro Dramox a Uživatele zavazují a společně s&nbsp;dalšími dokumenty (ceník,
            platební podmínky, akční nabídky atd.) tvoří smlouvu o poskytování služeb (&bdquo;Smlouva&ldquo;).
            V&nbsp;rámci Služby se Uživatel zavazuje hradit Dramoxu za poskytnuté Služby úplatu formou předplatného.
          </li>
          <li>
            Při objednání Služby zašle Dramox Uživateli potvrzení na e-mailovou adresu Uživatele uvedenou Uživatelem při
            registraci, a tím Dramox potvrdí uzavření Smlouvy. Toto e-mailové potvrzení bude obsahovat mimo jiné odkaz
            na tyto obchodní podmínky. Smlouva mezi Uživatelem a Dramoxem vzniká okamžikem, kdy Uživatel vyplní veškeré
            požadované registrační údaje a klikne na tlačítko Potvrdit. Smlouva představuje smlouvu uzavřenou
            elektronickými prostředky a bude uložena u Dramoxu.
          </li>
        </ul>
        <h2>Zpracování osobních údajů</h2>
        <ul>
          <li>
            Uživatel bere na vědomí, že v&nbsp;rámci poskytnutí služby dochází ke zpracování osobních údajů Uživatele
            Dramoxem jako správcem osobních údajů. Svou informační povinnost vůči Uživateli ve smyslu čl. 13 Nařízení
            Evropského parlamentu a Rady 2016/679 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a
            o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (obecné nařízení o ochraně osobních údajů)
            (&bdquo;GDPR&ldquo;) související se zpracováním osobních údajů kupujícího pro účely plnění Smlouvy, pro
            účely jednání o Smlouvě a pro účely plnění veřejnoprávních povinností Dramoxu plní Dramox prostřednictvím
            zvláštního dokumentu.
          </li>
        </ul>
        <h2 style={{ textAlign: 'left' }}>územní a věková omezení Služby</h2>
        <ul>
          <li>
            Služba je určena primárně k užívání na území České republiky. Uživatel je oprávněn užívat Službu po dobu
            dočasné přítomnosti mimo území České republiky na území členských států Evropského hospodářského prostoru v
            souladu s nařízením Evropského parlamentu a Rady 2017/1128{' '}
            <span className="Apple-converted-space">&nbsp; </span>o přeshraniční přenositelnosti on-line služeb
            poskytujících obsah v rámci vnitřního trhu (Toto oprávněné k&nbsp;dočasnému užití platí pro členské státy
            EU, Island, Lichtenštejnsko a Norsko.)
          </li>
          <li>
            V&nbsp;souvislosti s&nbsp;dočasným oprávněním ke sledování obsahu mimo území České republiky Dramox
            automaticky ověřuje, jestli je IP adresa Uživatele umístěna na území Evropského hospodářského prostoru.
            V&nbsp;případě, že určení toho údaje nebude možné nebo bude Uživatel využívat programové vybavení sloužící
            k&nbsp;obcházení identifikace IP adresy (vytváření virtuálních soukromých sítí VPN atp.), potom je Dramox
            oprávněn odmítnou poskytnutí Služby.
          </li>
          <li>
            Dramox obsahuje především záznamy divadelních představení a další audiovizuální díla, která do své nabídky
            zařazuje Dramox dle svého uvážení a na zařazení žádného obsahu nemá Uživatel nárok. Uživatel je oprávněn
            sledovat obsah zpřístupněný v&nbsp;databázi Dramoxu po uzavření Smlouvy. Přehled obsahu Služby je dostupný
            na Stránkách Dramoxu.
          </li>
          <li>
            Jakékoli změny obsahu a rozsahu nabízeného obsahu nepředstavují změnu Smlouvy mezi Dramoxem a Uživatelem.
          </li>
          <li>
            Dramox může obsahovat záznamy, které mohou být považovány za nevhodné pro děti či mladistvé a které by
            jinými osobami mohly být vnímány jako obscénní nebo znepokojivé. V&nbsp;takových případech je příslušný
            záznam náležitě označen věkovou hranicí, pro kterou je daný obsah přístupný. S&nbsp;ohledem na skutečnost,
            že Služba je primárně určena osobám starším 18 let, toto označení je informativní a Dramox nenese
            odpovědnost za zpřístupňování takto označeného obsahu nezletilým ze strany Uživatele. Uživatel je plně
            odpovědný za určení, zda je konkrétní obsah Služby vhodný pro děti nebo mladistvé.
          </li>
        </ul>
        <h2>Cena Služby</h2>
        <ul>
          <li>
            Uživatel se zavazuje za využívání Služby hradit Dramoxu odměnu formou měsíčního předplatného na základě
            platného Ceníku, který je k&nbsp;dispozici{' '}
            <AppLink href={Permalink.faq(locale)}>
              <a>ZDE</a>
            </AppLink>
            .
          </li>
          <li>
            Dramox umožní Uživateli po omezenou dobu vyzkoušet Službu bez povinnosti uhradit odměnu v&nbsp;rámci tzv.
            zkušební doby. Nárok na zkušební dobu má každý uživatel pouze jednou a po jejím vyčerpání je povinen buď
            uhradit předplatné nebo Dramox další užívání Služby bezplatně odmítne a obsah Uživateli znepřístupní.
          </li>
          <li>
            Pokud Uživatel během zkušební doby užívání Služby aktivně sám neukonční, bude jeho uživatelský účet
            automaticky převeden do standardního režimu a Dramox bude po Uživateli požadovat úhradu za Službu podle
            platného ceníku.
          </li>
          <li>
            První platba předplatného bude uskutečněna dne, kdy Uživatel uzavřel Smlouvu nebo kdy vypršela zkušební
            doba. Následně budou platby předplatného na následující měsíc hrazeny předem ke stejnému dni v měsíci, k
            jakému Uživatel uzavřel s&nbsp;Dramoxem Smlouvu. Pokud takový den v daném měsíci neexistuje, bude předplatné
            účtováno k poslednímu dni daného kalendářního měsíce.
          </li>
          <li>
            V&nbsp;případě, že platba nebude provedena nebo bude vystavitelem platební karty zamítnuta, Dramox omezí
            přístup ke Službě do doby, než bude platba Uživatelem provedena. Dramox je oprávněn ukončit Smlouvu v
            případě prodlení s platbou déle než 1 den.
          </li>
        </ul>
        <h2>Dárkové poukazy / vouchery</h2>
        <ul>
          <li>
            Odměnu za užití služby je možné hradit i prostřednictvím tzv. voucherů. Každý voucher obsahuje unikátní
            k&oacute;d, který uživatel vloží do příslušného pole při registraci nového uživatelského účtu.
          </li>
          <li>
            Voucher nelze uplatnit u uživatelských účtů, kde je nastavena platba platební kartou. V takovém případě je
            nutné vytvořit účet nový, případně stávající účet zrušit a s použitím stejné e-mailové adresy vytvořit účet
            nový, za který bude odměna zaplacena voucherem.&nbsp;
          </li>
          <li>
            V případě, že by k&oacute;d uvedený ve voucheru nebyl funkční, uživatel může Dramox kdykoli kontaktovat,
            Dramox ověří správnost reklamovaného k&oacute;du a zašle uživateli nový k&oacute;d.
          </li>
          <li>Platnost voucheru je 1 rok od jeho zakoupení.</li>
          <li>
            Vouchery je možné zakoupit prostřednictvím stránek Dramoxu. V případě, že uživatel zakoupí voucher,
            například jako dárek pro své blízké, obdrží na svou e-mailovou adresu odkaz, ze kterého si následně může
            voucher stáhnout, vytisknout, případně přeposlat obdarovanému. Vouchery nejsou určeny k dalšímu prodeji.
            Prodej voucheru není dovolený a je považován za hrubé porušení smluvních podmínek Dramoxu.
          </li>
          <li>
            Vouchery jsou nabízeny v různých hodnotách s různou délkou předplatného. Aktuální nabídku naleznete na
            stránkách Dramoxu.
          </li>
          <li>
            Voucher po zadání k&oacute;du do systému nelze vrátit a řídí se režimem popsaným v článku těchto obchodních
            podmínek s názvem &bdquo;Pozbytí práva na odstoupení&ldquo;.
          </li>
          <li>
            Vouchery si mohou zakoupit i komerční subjekty např. jako dárky pro své zaměstnance nebo klienty. Vouchery
            je možné objednat i ve zvláštním režimu pro školská a sociální zařízení. Pro zakoupení většího množství
            voucherů doporučujeme kontaktovat přímo obchodní oddělení Dramoxu na adrese{' '}
            <a href="mailto:martin@dramox.cz">martin@dramox.cz</a>.
          </li>
          <li>
            Vouchery pro platbu předplatného za službu Dramox jsou vydávány pouze Dramoxem, a tedy Dramox neodpovídá za
            nefunkčnost nebo jiné škody v souvislosti s vouchery zakoupenými mimo naše webové stránky nebo naše obchodní
            oddělení.
          </li>
        </ul>
        <h2>Podmínky užívání Služby</h2>
        <ul>
          <li>
            Pro bezproblémové užívání Služby je nezbytná registrace Uživatele, který současně bude mít k&nbsp;dispozici
            zařízení splňující minimální technické požadavky a připojení k&nbsp;internetu.
            <span className="Apple-converted-space">
              <br />
            </span>
          </li>
          <li>
            Doporučujeme ověřit parametry internetového připojení, zejména minimální rychlost, která by neměla být nižší
            než 2Mbps a současně případná omezení na množství stahovaných dat.
          </li>
          <li>
            Sledování obsahu Dramoxu je náročné na množství stažených dat, a proto pro jeho sledování není vhodně
            připojení, které je jakkoli omezeno co do výše stažených dat. Za případné poplatky spojené s&nbsp;objemem
            stažených dat, které mohou někteří poskytovatelé internetového připojení účtovat, nenese Dramox odpovědnost.
          </li>
          <li>
            V&nbsp;souladu s platnými právními předpisy není Dramox odpovědný za neschopnost Uživatele užívat Službu
            nebo za omezený přístup ke Službě z důvodu přetížení sítě Internet nebo v důsledku chyby nebo problémů
            týkajících se zařízení, sítí, elektroniky nebo komunikací, které jsou mimo kontrolu Dramoxu.
          </li>
        </ul>
        <h2>Uživatelský účet</h2>
        <ul>
          <li>
            Uživatel se registruje na adrese Dramox.cz v&nbsp;sekci &bdquo;Registrace&ldquo;. K&nbsp;registraci je nutné
            vyplnit požadované identifikační údaje a údaje o způsobu platby, kterou je možné provádět pouze
            prostřednictvím platebních (kreditních, debetních) karet vydaných na území České republiky.
            <span className="Apple-converted-space">&nbsp;</span>
          </li>
          <li>
            V&nbsp;okamžiku registrace Dramox automaticky provede ověření IP adresy dle článku 3.2 těchto obchodních
            podmínek.
          </li>
          <li>
            Uživatel se zavazuje uvést v&nbsp;registraci pravdivé údaje v&nbsp;a případě jejich změny tyto údaje bez
            zbytečného odkladu aktualizovat.
          </li>
          <li>
            Ke zpracování plateb využívá Dramox platební bránu společnosti Stripe a zpracování plateb se řídí jejími
            obchodními podmínkami, se kterými se Uživatel může seznámit{' '}
            <a href="https://stripe.com/en-cz/privacy">ZDE</a>.
          </li>
          <li>
            V&nbsp;rámci registrace nového Uživatele bude Uživatel vyzván k&nbsp;zadání následujících údajů:
            přihlašování jméno, jméno, příjmení, e-mailová adresa, heslo, údaje týkající se zvoleného způsobu platby,
            případně jiné údaje, které mohou být požadovány a jsou nezbytné k provedení registrace. Přihlašovací jméno
            Uživatele je osobní a nesmí být použity třetí osobou. V&nbsp;případě, že dojde ke zneužití Přihlašovacího
            jména a Dramox tuto skutečnost zjistí, je oprávněn odmítnou další poskytnutí Služby a uživatelský účet
            zablokovat nebo smazat a ukončit Smlouvu s&nbsp;Uživatelem s&nbsp;okamžitou platností.
          </li>
          <li>
            Dramox může Uživatele vyzvat, aby si změnil heslo, jestliže nesplňuje pravidla zabezpečení a hrozí jeho
            zneužití.
          </li>
        </ul>
        <h2 style={{ textAlign: 'left' }}>Licenční podmínky Služby</h2>
        <ul>
          <li>
            Uživatel je oprávněn užívat Službu pro osobní potřebu a v souladu s těmito obchodními podmínkami. Uživatel
            není oprávněn užívat Službu pro komerční účely nebo veřejné produkce, pořizovat kopie/ rozmnoženiny,
            půjčovat, prodávat, vysílat ani jinak šířit, pozměňovat nebo jakýmkoliv jiným způsobem převádět nebo
            upravovat obsah Služby, obcházet, upravovat, odstraňovat, měnit nebo jakýmkoliv jiným způsobem manipulovat
            se zabezpečením, šifrováním nebo jinou technologií nebo softwarem, který je součástí Služby, a jinak užívat
            Službu v rozporu se zákony o právu autorském, jinými zákony nebo těmito obchodními podmínkami.
          </li>
          <li>
            V souvislosti s uzavřením Smlouvy uděluje Dramox Uživateli nevýhradní, nepřenosnou a omezenou licenci ke
            sledování obsahu Služby. Uživatel smí Službu a její obsah užívat pouze v souladu se Smlouvou a pro soukromé
            účely.
          </li>
          <li>
            Materiály na Stránkách a obsah Služby jsou chráněny autorským právem a dalšími předpisy o ochraně duševního
            vlastnictví. Smlouva v žádném případě nezakládá převod vlastnického práva ani jiného práva duševního
            vlastnictví k obsahu Služby nebo Služby na Uživatele.
          </li>
          <li>
            Porušení tohoto ustanovení obchodních podmínek se považuje za hrubé porušení Smlouvy a Dramox je
            v&nbsp;případě jeho zjištění oprávněn okamžitě ukončit Smlouvu s&nbsp;Uživatelem a využizí současně všechny
            dostupné právní prostředky k&nbsp;ochraně svých práv a práv držitelů autorských práv k&nbsp;záznamům, které
            tvoří obsah Dramoxu.
          </li>
        </ul>
        <h2 style={{ textAlign: 'left' }}>Změny Smlouvy</h2>
        <ul>
          <li style={{ textAlign: 'left' }}>
            Dramox je oprávněn měnit výši předplatného a další podmínky užívání Služby dle svého uvážení, vždy však
            s&nbsp;dostatečným předstihem. Uživatel bude o takových změnách informován e-mailem uvedeným v&nbsp;jeho
            uživatelském účtu, a to nejpozději třicet (30) dní před účinností dané změny. V&nbsp;případě, že Uživatel
            nebude se změnou souhlasit, je oprávněn ukončit Smlouvu s účinností k datu účinnosti dané změny.
            <span className="Apple-converted-space">&nbsp;</span>
          </li>
        </ul>
        <h2>Pozbytí práva na odstoupení</h2>
        <ul>
          <li>
            Uzavřením Smlouvy Uživatel výslovně uděluje souhlas s poskytováním Služby ihned po uzavření Smlouvy a
            zaplacení předplatného dle Smlouvy. Uživatel tímto bere na vědomí, že s ohledem na to, že získá přístup ke
            Službě před uplynutím čtrnáctidenní (14 denní) lhůty pro odstoupení od Smlouvy, pozbývá právo odstoupit od
            smlouvy v souladu s &sect; 1829 zákona č. 89/2012 Sb., občanského zákoníku, ve znění pozdějších předpisů, ve
            lhůtě čtrnácti (14) dnů od uzavření Smlouvy.&nbsp;
          </li>
          <li>
            Tento článek nemá vliv na právo Uživatele ukončit Smlouvu kdykoliv během Zkušení Doby bez povinnosti uhradit
            předplatné.
          </li>
        </ul>
        <h2 style={{ textAlign: 'left' }}>Trvání Smlouvy</h2>
        <ul>
          <li>
            Smlouva se uzavírá na dobu předplatného vždy v délce jeden (1) měsíc a je automaticky prodlužována vždy o
            jeden (1) měsíc, dokud Uživatel nebo Dramox Smlouvu neukončí v souladu s těmito obchodními podmínkami.
          </li>
          <li>
            Pokud si Uživatel přeje ukončit Smlouvu, musí tuto skutečnost oznámit Dramoxu v&nbsp;uživatelské sekci
            Stránek, s&nbsp;tím, že Smlouva skončí ke konci aktuálního předplaceného kalendářního měsíce.
          </li>
          <li>
            Dramox je oprávněn ukončit Smlouvu v&nbsp;případě, kdy:
            <ul>
              <li>Uživatel je v prodlení s platbou po dobu méně než 1 den,</li>
              <li>Uživatel zneužije Zkušební dobu nebo poruší její podmínky;</li>
              <li>
                Služba je užívána Uživatelem neoprávněně nebo existuje důvodné podezření, že dochází k neoprávněnému
                užívání,
              </li>
              <li>Uživatel se pokusil využít Zkušební dobu více než jedenkrát (1x), nebo</li>
              <li>Uživatel jiným způsobem podstatně porušil Smlouvu nebo opakovaně porušil Smlouvu</li>
            </ul>
          </li>
        </ul>
        <h2>Omezení odpovědnosti, výpadky Služby</h2>
        <ul>
          <li>
            Za poruchy, výpadky a jiné nedostatky, které mají za následek, že Službu nelze užít po nepřetržitou dobu
            překračující 24 hodin a které jsou způsobeny z&nbsp;důvodů na straně Dramoxu, má Uživatel, který o to
            požádá, nárok na poměrné snížení předplatného.
          </li>
          <li>
            Uživatel nemá nárok na jakoukoliv náhradu za přerušení, výpadky nebo jiné nedostatky Služby, které jsou
            důsledkem údržby. údržba je prováděna jednou během kalendářního měsíce mezi 0:00 hodinou a 8:00 hodinou
            ranní. V&nbsp;průběhu údržby může být Služba nedostupná.
          </li>
        </ul>
        <h2>Povinnost k&nbsp;náhradě škody</h2>
        <ul>
          <li>
            Uživatel je povinen odškodnit Dramox, resp. jej zbavit odpovědnosti, za k jakékoli ztráty, výdaje nebo
            nároky vzniklé v důsledku nebo v souvislosti s porušením Smlouvy, porušením příslušných zákonů nebo porušení
            práv třetích stran Uživatelem.
          </li>
        </ul>
        <h2>Postoupení práv a povinností</h2>
        <ul>
          <li>
            Dramox je oprávněn postoupit svá práva a povinnosti vyplývající ze Smlouvy třetí straně, o níž lze přiměřeně
            předpokládat, že bude řádně plnit povinnosti vůči Uživateli a v souladu se Smlouvou. Uživatel není oprávněn
            postoupit svá práva a povinnosti vyplývající ze Smlouvy.
          </li>
        </ul>
        <h2 style={{ textAlign: 'left' }}>Odkazy na obsah třetích stran</h2>
        <ul>
          <li>
            Stránky Dramoxu mohou obsahovat odkazy na jiné internetové stránky provozované třetími stranami. Dramox nemá
            nad takovými odkazy ani obsahem takových internetových stránek kontrolu a nepřejímá za ně žádnou
            odpovědnost. Uživatel užívá takové internetové stránky na vlastní nebezpečí.
          </li>
        </ul>
        <h2>Řešení sporů</h2>
        <ul>
          <li>
            V&nbsp;případě vzniku sporu mezi Uživatelem a Dramoxem může Uživatel kontaktovat Dramox prostřednictvím
            kontaktních údajů uvedených na konci těchto obchodních podmínek nebo jiných kontaktních údajů dostupných na
            Stránkách.
          </li>
          <li>
            Uživatel a Dramox se pokusí vyřešit spory smírnou cestou. V&nbsp;případě, že nalezené smírného řešení nebude
            možné, bude spor vyřešen příslušným soudem v České republice.
            <span className="Apple-converted-space">&nbsp;</span>
          </li>
        </ul>
        <h2>Rozhodné právo</h2>
        <ul>
          <li>Smlouva a právní vztahy mezi Uživatelem a Dramoxem se řídí právním řádem České republiky.</li>
          <li>
            V&nbsp;případě nemožnosti nalezení smírného řešení sporu mezi Uživatelem a Dramoxem má Uživatel před podáním
            žaloby k soudu nárok předložit stížnost České obchodní inspekci, jakožto orgánu oprávněnému řešit stížnosti
            spotřebitelů a spory mimosoudní cestou, nebo využít možnosti online řešení spotřebitelských sporů. Pokud jde
            o obsah Služby může Uživatel rovněž podat stížnost k Radě pro rozhlasové a televizní vysílání.
          </li>
        </ul>
        <h2>Komunikace a kontaktní údaje</h2>
        <ul>
          <li>
            Dramox je oprávněn zasílat Uživateli oznámení prostřednictvím e-mailu nebo zveřejněním na oznámení na
            Stránkách.
          </li>
          <li>
            Uživatel může Dramox kontaktovat na adrese Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00 Praha 5,
            Aspira Business Centre, Česká republika, nebo e-mailové adrese{' '}
            <a href="mailto:napoveda@dramox.cz">napoveda@dramox.cz</a>.
          </li>
        </ul>
      </>
    );
  };

  const enTerms = () => {
    return (
      <>
        <p className={styles.updated}>Updated 26.11.2020</p>
        <h1>Terms &amp; Conditions</h1>
        <h2>General</h2>
        <ul>
          <li>
            Dramox s.r.o., a company with its registered office at Bucharova 2928/14a, Stodůlky, 158 00 Prague 5, Aspira
            Business Centre, registered in the Commercial Register kept by the Municipal Court in Prague, Section C,
            File 332337 (&ldquo;<strong>Dramox</strong>&rdquo;), provides on-demand audiovisual media services under the
            name Dramox at dramox.cz or in an application created by Dramox (the &ldquo;<strong>Website</strong>&rdquo;)
            with on-demand contents available on the Internet (the &ldquo;<strong>Services</strong>&rdquo;).
          </li>
          <li>
            The General Terms and Conditions shall apply to agreements on the provision of the Services between Dramox
            and the user as a natural person (the &ldquo;<strong>User</strong>&rdquo;), and between Dramox and business
            entities and/or public institutions, such as schools and social facilities. Only persons over 18 years of
            age with their permanent residence in the territory of the Czech Republic may enter into an agreement on the
            provision of the Services with Dramox; persons under 18 years of age may do so only through their legal
            representatives. Dramox may refuse to enter into an agreement with a User or terminate an agreement with a
            User with immediate effect if the User breaches these Terms and Conditions.
          </li>
          <li>
            These Terms and Conditions are binding on Dramox and the Users, and together with other documents (price
            list, payment terms, special offers, etc.), form an agreement on the provision of the Services (the &ldquo;
            <strong>Agreement</strong>&rdquo;). The User agrees to pay a subscription fee to Dramox for the Services
            provided.
          </li>
          <li>
            When Services have been ordered, Dramox shall send a confirmation to the User, to the User&rsquo;s e-mail
            address specified by the User during registration, thereby confirming the conclusion of the Agreement. The
            e-mail confirmation will include, <em>inter alia</em>, a reference to these Terms and Conditions. The
            Agreement between the User and Dramox is made once the User fills in all the required registration details
            and clicks on the &ldquo;Confirm&rdquo; button. The Agreement represents an agreement executed by electronic
            means and will be deposited with Dramox.
          </li>
        </ul>

        <h2>Personal Data Processing</h2>
        <ul>
          <li>
            The User acknowledges that the User&rsquo;s personal data are being processed within the provision of
            Services by Dramox as the personal data controller. Dramox fulfils its notification obligation towards the
            User within the meaning of Article 13 of Regulation 2016/679 of the European Parliament and of the Council
            on the protection of natural persons with regard to the processing of personal data and on the free movement
            of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) (the &ldquo;
            <strong>GDPR</strong>
            &rdquo;) related to the processing of the User&rsquo;s personal data for the purposes of performance of the
            Agreement, for the purpose of negotiations regarding the Agreement and for the purpose of fulfilment of
            public-law duties, by means of a special{' '}
            <AppLink href={Permalink.privacyPolicy(locale)}>
              <a>document</a>
            </AppLink>
            .
          </li>
        </ul>

        <h2>Territorial and age limitations of the Services</h2>
        <ul>
          <li>
            The Services are intended primarily for the use in the territory of the Czech Republic. The User may use the
            Services outside the territory of the Czech Republic while being temporarily present in the territory of
            Member States of the European Economic Area in accordance with Regulation 2017/1128 of the European
            Parliament and of the Council on cross-border portability of online content services in the internal market
            (this authorisation for temporary use applies to EU Member States, Iceland, Liechtenstein and Norway).
          </li>
          <li>
            In connection with the temporary authorisation to watch the content outside the Czech Republic, Dramox
            automatically verifies whether the User&rsquo;s IP address is located in the territory of the European
            Economic Area. If it is not possible to obtain this information or if the User uses software to circumvent
            the IP address identification (creation of VPN networks, etc.), Dramox may refuse to provide the Services.
          </li>
          <li>
            The Services provided by Dramox comprise, in particular, recordings of theatre performances and other
            audiovisual works which are included in Dramox&rsquo;s offer according to its own discretion, and the User
            is not entitled to any content. The User may watch the content made available in the Dramox database after
            the execution of the Agreement. An overview of the contents of the Services is available on the Dramox
            Website.
          </li>
          <li>
            Any changes in the content and in the scope of the content offered do not constitute an amendment to the
            Agreement between Dramox and the User.
          </li>
          <li>
            The Services provided by Dramox may contain recordings that could be considered inappropriate for children
            and adolescents, and that could be perceived by other persons as obscene or disturbing. In such cases, an
            age limit for access to the given content will be properly displayed in the relevant recording. In view of
            the fact that the Services are intended primarily for persons over 18 years of age, this sign is indicative
            only and Dramox cannot be held responsible if the content thus designated is made accessible by the User to
            minors. The User is fully responsible for determining whether any specific content of the Services is
            suitable for children and adolescents.
          </li>
        </ul>

        <h2>Price of the Services</h2>
        <ul>
          <li>
            The User agrees to pay to Dramox a fee for the use of the Services in the form of a monthly subscription fee
            based on the applicable price list, which is available{' '}
            <AppLink href={Permalink.faq(locale)}>
              <a>HERE</a>
            </AppLink>
            .
          </li>
          <li>
            Dramox will enable the User to test the Services for a limited period of time without the obligation to pay
            a fee within a &ldquo;Trial Period&rdquo;. A Trial Period is available only once to each User and the User
            is obliged to pay the subscription fee after its expiry; otherwise, Dramox will reject further use of the
            Services free of charge and render the content inaccessible to the User.
          </li>
          <li>
            Unless the User actively terminates the Services during the Trial Period, his/her user account will be
            automatically transferred to the standard regime and Dramox will request payment for the Services from the
            User according to the applicable price list.
          </li>
          <li>
            The first payment of the subscription fee will be made on the date when the User enters into the Agreement
            or when the Trial Period expires. Subsequently, the subscription fees for each following month will be paid
            in advance on the same day in the given month as that on which the User and Dramox entered into the
            Agreement. If no such day exists in the given month, the subscription fee will be charged as of the last day
            of the given calendar month.
          </li>
          <li>
            If the payment is not made or if the card issuer rejects the payment, Dramox will restrict access to the
            Services until the payment is made by the User. Dramox may terminate the Agreement in the event of a delay
            in payment exceeding 1 day.
          </li>
        </ul>

        <h2>Gift certificates / vouchers</h2>
        <ul>
          <li>
            The fee for the use of the Services can also be paid by means of &ldquo;vouchers&rdquo;. Each voucher
            contains a unique code to be entered by the User in the relevant field when registering a new user account.
          </li>
          <li>
            Vouchers cannot be used with user accounts where payment by card has been selected. In that case, it is
            necessary to create a new account, or cancel the existing account and create a new account using the same
            e-mail address where the payment will be made by means of a voucher.
          </li>
          <li>
            If the code specified in the voucher is not functional, the User may contact Dramox at any time; Dramox will
            verify the accuracy of the claimed code and send a new code to the User.
          </li>
          <li>The voucher is valid for 1 year after its purchase.</li>
          <li>
            Vouchers can be purchased via the Dramox Website. If the User buys a voucher, e.g. as a gift for a
            friend/relative, the User will receive an e-mail with a link, which can then be used to download the
            voucher, print it out or forward it to the recipient of the gift. Vouchers are not intended for resale.
            Resale of vouchers is not permitted and is considered to be a material breach of Dramox&rsquo;s terms and
            conditions.
          </li>
          <li>
            Vouchers of various values and periods of subscription are offered. An up-to-date offer is available at
            Dramox&rsquo;s Website.
          </li>
          <li>
            After entering the code into the system, the voucher cannot be returned and is subject to the regime
            specified in the article &ldquo;Loss of the right to withdraw&rdquo; hereof.
          </li>
          <li>
            Vouchers can also be purchased by commercial entities, e.g. as gifts for their employees or clients.
            Vouchers can also be ordered in a special regime for schools and social facilities. For purchasing a larger
            number of vouchers, we recommend contacting the Dramox sales department directly at{' '}
            <a href="mailto:support@dramox.tv">support@dramox.tv</a>.
          </li>
          <li>
            Vouchers for subscription for the Services are issued only by Dramox and, therefore, Dramox is not liable
            for malfunction or other damage in connection with vouchers purchased outside our Website or our sales
            department.
          </li>
        </ul>

        <h2>Terms of use of the Services</h2>
        <ul>
          <li>
            <h2></h2>
            In order to ensure smooth use of the Services, it is necessary that the registered User have at his/her
            disposal a device that meets the minimum technical requirements and is connected to the Internet.
          </li>
          <li>
            We recommend to verify the parameters of the internet connection, especially the minimum speed, which should
            not be lower than 2 Mbps, and also any potential limitations to the volume of data downloaded.
          </li>
          <li>
            Watching the Dramox content is demanding in terms of the volume of downloaded data and, therefore, is not
            suitable for connections that are in any way limited in this respect. Dramox is not liable for any fees
            related to the volume of data downloaded that may be charged by some internet service providers.
          </li>
          <li>
            In compliance with the applicable legal regulations, Dramox is not responsible for the User&rsquo;s
            inability to use the Services or for limited access to the Services due to internet connection overload or
            as a result of an error or problems concerning equipment, networks, electronics or communications beyond the
            control of Dramox.
          </li>
        </ul>

        <h2>User Account</h2>
        <ul>
          <li>
            The User registers at Dramox.cz in the &ldquo;Registration&rdquo; section. In order to register, it is
            necessary to fill in the required identification details and details on the manner of payment, which can
            only be made by payment cards (credit, debit) issued in the territory of the Czech Republic.
          </li>
          <li>
            At the time of registration, Dramox will automatically verify the IP address pursuant to Art. 3.2 hereof.
          </li>
          <li>
            The User agrees to provide accurate information in the registration and update this information without
            undue delay in case of any change.
          </li>
          <li>
            Dramox uses the Stripe payment gateway for processing payments; processing of payments is governed by
            Stripe&rsquo;s terms and conditions, which are available to the User{' '}
            <a href="https://stripe.com/en-cz/privacy" target="_blank">
              HERE
            </a>
            .
          </li>
          <li>
            Within the registration of a new user, the User will be requested to enter the following details: login,
            name, surname, e-mail address, password, details concerning the selected method of payment, and other data
            as may be required and necessary for the registration. The User&rsquo;s login is personal and may not be
            used by a third party. If Dramox ascertains that a login has been misused, Dramox may refuse to provide any
            further Services, and may block or delete the user account and terminate the Agreement with the User with
            immediate effect.
          </li>
          <li>
            Dramox may request that the User change the password if it does not meet the security rules and if there is
            a risk of its misuse.
          </li>
        </ul>

        <h2>Licence terms and conditions of the Services</h2>
        <ul>
          <li>
            The User may use the Services for his/her personal needs and in accordance with these Terms and Conditions.
            The User is not entitled to use the Services for commercial purposes or public production, make
            copies/reproductions, rent, sell, broadcast or otherwise disseminate, alter or transfer or otherwise modify
            the contents of the Services, circumvent, modify, remove, change or otherwise tamper with the security,
            encryption or other technology or software that is part of the Services, or otherwise use the Services at
            variance with the laws on copyright, other laws or these Terms and Conditions.
          </li>
          <li>
            In connection with the execution of the Agreement, Dramox grants to the User a non-exclusive,
            non-transferrable and limited licence to watch the contents of the Services. The User may use the Services
            and its contents only in accordance with the Agreement and for private purposes.
          </li>
          <li>
            Materials on the Website and the contents of the Services are protected by copyright and other regulations
            on the protection of intellectual property. The Agreement in no case establishes a transfer of the ownership
            title or any other intellectual property right to the Services or the contents of the Services to the User.
          </li>
          <li>
            Breach of this provision hereof shall be deemed to be material breach of the Agreement and, if any such
            breach is determined, Dramox may immediately terminate the Agreement with the User and, at the same time,
            use all available remedies to protect its rights and rights of the holders of copyright to the recordings
            constituting the contents of the Dramox Services.
          </li>
        </ul>

        <h2>Amendments to the Agreement</h2>
        <ul>
          <li>
            Dramox may change the amount of the subscription fee and other terms of use of the Services according to its
            own discretion, but always sufficiently in advance. The User will be informed of any such changes at the
            e-mail address specified in his/her user account not later than thirty (30) days before the effective date
            of the change. If the User disagrees with the change, the User may terminate the Agreement with effect as of
            the effective date of the given change.
          </li>
        </ul>

        <h2>Loss of the right to withdraw</h2>
        <ul>
          <li>
            By entering into the Agreement, the User expressly grants his/her consent to the provision of the Services
            immediately after execution of the Agreement and payment of the subscription fee under the Agreement. The
            User hereby acknowledges that, since the User obtains access to the Services before expiry of the
            fourteen-day (14-day) deadline for withdrawal from the Agreement, the User loses the right to withdraw from
            the Agreement within fourteen (14) days of execution thereof pursuant to Section 1829 of Act No. 89/2012
            Coll., the Civil Code, as amended.
          </li>
          <li>
            This Article shall in no way prejudice the User&rsquo;s right to terminate the Agreement at any time during
            the Trial Period without the obligation to pay the subscription fee.
          </li>
        </ul>

        <h2>Term of the Agreement</h2>
        <ul>
          <li>
            The Agreement is entered into in each case for a subscription period of one (1) month case and will be
            automatically repeatedly prolonged by one (1) month periods until the User or Dramox terminates the
            Agreement in accordance with these Terms and Conditions.
          </li>
          <li>
            If the User wishes to terminate the Agreement, he/she must notify Dramox of this fact in the user section of
            the Website, and the Agreement will terminate as of the end of the currently prepaid calendar month.
          </li>
          <li>
            Dramox may terminate the Agreement if:
            <ul>
              <li>the User is in delay with payment for a period of at least 1 day;</li>
              <li>the User misuses the Trial Period or breaches its terms and conditions;</li>
              <li>
                the Services are used by the User without authorisation or there is a justified suspicion of
                unauthorised use;
              </li>
              <li>the User has attempted to use the Trial Period more than once (1x); or</li>
              <li>
                the User materially breaches the Agreement or has repeatedly breached the Agreement in some other
                manner.
              </li>
            </ul>
          </li>
        </ul>

        <h2>Limitation of liability; Service outages</h2>
        <ul>
          <li>
            In case of malfunctions, outages and other shortcomings as a result of which it is not possible to use the
            Services for a continuous period of time exceeding 24 hours and that are caused by reasons on the part of
            Dramox, the User is entitled to a proportional reduction of the subscription fee if the User so requests.
          </li>
          <li>
            The User is not entitled to any compensation for interruption, outages or other shortcomings of the Services
            resulting from maintenance. The maintenance is performed once a calendar month between 00:00 a.m. and 8:00
            a.m. The Services may not be available during the maintenance.
          </li>
        </ul>

        <h2>Compensation for damage</h2>
        <ul>
          <li>
            The User is required to indemnify Dramox or release Dramox from liability for any loss, expenses or claims
            arising as a result of or in relation to breach of the Agreement, breach of the applicable laws or
            infringement of third-party rights by the User.
          </li>
        </ul>

        <h2>Assignment of rights and obligations</h2>
        <ul>
          <li>
            Dramox may assign its rights and obligations following from the Agreement to a third party that can be
            reasonably expected to perform its obligations towards the User properly and in accordance with the
            Agreement. The User may not assign his/her rights and obligations following from the Agreement.
          </li>
        </ul>

        <h2>Links to third-party content</h2>
        <ul>
          <li>
            The Dramox Website may contain links to other websites operated by third parties. Dramox has no control over
            such links or contents of such websites and assumes no responsibility for them. The User uses such websites
            at his/her own risk.
          </li>
        </ul>

        <h2>Resolution of disputes</h2>
        <ul>
          <li>
            In case of any dispute between the User and Dramox, the User may contact Dramox using the contact details
            specified at the end of these Terms and Conditions or other contact details available on the Website.
          </li>
          <li>
            The User and Dramox shall strive to resolve the disputes amicably. If an amicable settlement cannot be
            reached, the dispute will be resolved by the Czech court having the relevant jurisdiction.
          </li>
        </ul>

        <h2>Governing law</h2>
        <ul>
          <li>
            This Agreement and legal relationships between the User and Dramox are governed by the laws of the Czech
            Republic.
          </li>
          <li>
            If an amicable settlement of a dispute between the User and Dramox cannot be reached, the User may submit a
            complaint to the{' '}
            <a href="https://www.coi.cz/" target="_blank">
              Czech Trade Inspection Authority
            </a>
            , as the authority authorised to resolve consumer complaints and disputes out of court, or use the option
            of&nbsp;
            <a href="https://ec.europa.eu/consumers/odr" target="_blank">
              on-line resolution of consumer disputes
            </a>
            , before filing a lawsuit. As regards the contents of the Services, the User may also file a complaint with
            the&nbsp;
            <a href="https://www.rrtv.cz/" target="_blank">
              Council for Radio and Television Broadcasting
            </a>
            .
          </li>
        </ul>

        <h2>Communication and contact details</h2>
        <ul>
          <li>Dramox may send notifications to the User by e-mail or by publishing a notice on the Website.</li>
          <li>
            The User may contact Dramox at Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00 Prague 5, Aspira Business
            Centre, Czech Republic, or by e-mail at <a href="mailto:support@dramox.tv">support@dramox.tv</a>.
          </li>
        </ul>
      </>
    );
  };

  const ukTerms = useCallback(
    () => (
      <>
        <p className={styles.updated}>Опубліковано: 11 лютого 2022 року</p>
        <h1>Публічна &amp; оферта</h1>
        <p>
          Ця Публічна оферта («Умови використання» або «Умови») містить умови договору приєднання («Договір») між Dramox
          s.r.o., компанією, що діє під комерційним найменуванням Dramox («Dramox» або «Виконавець») і надає доступ до
          сервісу, в межах цього Договору, та вами, як користувачем («Користувач», «ви»).
        </p>
        <p>
          Будь ласка, ознайомтесь з цими Умовами, оскільки приєднанням до Договору вважатимуться ваші конклюдентні дії.
          У разі незгоди з цими Умовами, приєднання до Договору і отримання Послуг не є можливим.
        </p>
        <h2>1. Визначення термінів</h2>
        <p className={styles.paragraph}>
          <span>Авторизація</span> – введення зареєстрованим Користувачем свого логіна і паролю для доступу до
          особистого кабінету.
        </p>
        <p className={styles.paragraph}>
          <span>Вебсайт</span> – вебсайт, доступний за посиланням{' '}
          <a href="https://www.dramox.tv/">https://www.dramox.tv</a>
        </p>
        <p className={styles.paragraph}>
          <span>Договір</span> – термін, що об’єднує в собі ці Умови разом з Політикою конфіденційності та іншими
          документами (спеціальні пропозиції, прейскурант тощо).
        </p>
        <p className={styles.paragraph}>
          <span>Користувачі</span> – фізичні особи, що мають необхідний обсяг дієздатності за законодавством України або
          іншої країни, з якої здійснюється перегляд, особи, що діють через свого законного представника, а також
          юридичні особи, за наявності технічних можливостей для використання Сервісу. Dramox залишає за собою право
          відмовити в укладенні Договору або негайно його розірвати, якщо Користувач порушить ці Умови.
        </p>
        <p className={styles.paragraph}>
          <span>Онлайн-театр</span> – сукупність програмних засобів, інтерфейсів та інформації, об'єднаних простором
          доменного імені <a href="https://www.dramox.tv/">https://www.dramox.tv</a> та його субдоменів, що забезпечують
          Користувачеві надання Послуг.
        </p>
        <p className={styles.paragraph}>
          <span>Особистий кабінет</span> Особистий кабінет – унікальний обліковий запис Користувача в Онлайн-театрі, що
          адмініструється Виконавцем і через який Користувач отримує доступ до Послуг. Користувач має право припинити
          дію Облікового запису в будь-який момент, скориставшись відповідними налаштуваннями.
        </p>
        <p className={styles.paragraph}>
          <span>Послуги</span> – індивідуальний доступ до Онлайн-театру, зокрема, перегляд контенту за запитом, шляхом
          адресного повідомлення (передачі) кодованого аудіовізуального медіа за допомогою сервісу Dramox методом
          стрімінгу.
        </p>
        <p className={styles.paragraph}>
          <span>Сервіс</span> – персональний сервіс Dramox, що надається Користувачу, зокрема, Послуги та/або інші
          функції, інструменти, рекомендації, контент тощо.
        </p>
        <p className={styles.paragraph}>
          <span>Твори</span> – театральні вистави та інші аудіовізуальні твори.
        </p>
        <h2>2. Обробка персональних даних</h2>
        <p>Обробка персональних даних здійснюється згідно з Політикою конфіденційності Dramox.</p>
        <p>
          Користувач визнає, що персональні дані обробляються в рамках надання Послуг компанією Dramox, як володільцем
          персональних даних.
        </p>
        <h2>3. Послуги</h2>
        <p>
          Отримання Послуг можливе лише за умови використання вами відповідних пристроїв, підключених до мережі
          інтернет. Якість Послуг у тому числі залежить від швидкості вашого інтернет-з’єднання та технічних
          властивостей вашого пристрою.
        </p>
        <p>
          Ми рекомендуємо перевірити параметри інтернет-з'єднання, особливо мінімальну швидкість, яка не повинна бути
          нижчою за 2 Мбіт/с, а також будь-які потенційні обмеження обсягу завантажуваних даних.
        </p>
        <p>
          Ви погоджуєтесь, що Виконавець надає Послуги, використовуючи сервіси сторонніх осіб, і не несе
          відповідальності за можливі несправності у роботі Онлайн-театру. У свою чергу, Виконавець в межах своїх
          можливостей докладає максимальних зусиль, аби забезпечити безперешкодний доступ Користувачів до Послуг.
        </p>
        <p>
          Dramox не несе відповідальності за будь-які збори та інші додаткові платежі, пов’язані з обсягом завантажених
          даних, що можуть стягуватися деякими провайдерами інтернет послуг.
        </p>
        <p>
          Онлайн-театр, що доступний для користування в межах доменного імені{' '}
          <a href="https://www.dramox.tv/">https://www.dramox.tv</a> та його субдоменів, а також через мобільні додатки
          та/або додатки для SMART-TV, пропонує платні Послуги з тимчасового доступу до перегляду записів Творів, а
          також інші Послуги, визначені Договором.
        </p>
        <p>
          Онлайн-театр призначений переважно для використання на території України. Користувач може також
          використовувати Онлайн-театр за її межами, тимчасово перебуваючи на території держав-членів Європейської
          економічної зони.
        </p>
        <p>
          Dramox автоматично перевіряє, чи розташована IP-адреса Користувача на зазначеній території. Якщо отримати цю
          інформацію неможливо або якщо Користувач використовує програмне забезпечення для зміни IP-адреси (створення
          мереж VPN тощо), Dramox може відмовити в наданні доступу до Онлайн-театру.
        </p>
        <p>
          Послуги включають, зокрема, доступ до Творів, які Dramox обирає на власний розсуд. Користувач може переглядати
          Твори, доступні у базі даних Dramox, після приєднання до Договору.
        </p>
        <p>
          Будь-які зміни в частині змісту та обсягу Творів, розміщених в базі даних, не впливають на Договір, укладений
          між Dramox та Користувачем.
        </p>
        <p>
          Твори можуть містити епізоди, що вважаються неприйнятними для дітей та осіб з підвищеним рівнем чутливості.
          Такі Твори містять маркування з віковим обмеженням. Оскільки Сервіс призначений в першу чергу для осіб, що
          досягли повноліття і мають необхідний обсяг дієздатності, маркування є орієнтовним і Dramox не несе
          відповідальність за випадки, коли Твори стали доступні іншим особам.
        </p>
        <p>
          Користувач визначає чи підходить будь-який конкретний Твір для нього особисто та осіб, з якими він здійснює
          перегляд, на власний страх і ризик, і самостійно несе за це відповідальність.
        </p>
        <h2>4. Ціна, строк та порядок приймання-передачі Послуг</h2>
        <p>
          Для отримання Послуг Користувач погоджується сплачувати Dramox абонентську плату. Обробка платежів
          здійснюється за допомогою платіжного шлюзу Stripe, діяльність якого регулюється окремими правилами,
          розміщеними <a href="https://stripe.com/gb/checkout/legal">тут</a>.
        </p>
        <p>
          У разі виникнення проблем із надходженням платежу на рахунок Dramox, Користувач самостійно вирішує таку
          проблему, а Dramox в межах своїх можливостей та у розумні строки надає інформацію про стан оплати на ваш
          запит.
        </p>
        <p>
          Після замовлення Послуг Dramox надсилає Користувачеві підтвердження на адресу електронної пошти Користувача,
          зазначену під час створення облікового запису, підтверджуючи тим самим укладення Договору.
        </p>
        <p>
          Відправлене підтвердження, серед іншого, міститиме посилання на ці Умови. Договір між Користувачем та Dramox
          укладається після того, як Користувач заповнить усі необхідні реєстраційні дані та натисне кнопку
          «Підтвердити». Договір укладається за допомогою електронних засобів та зберігається у Dramox.
        </p>
        <p>
          Оплата здійснюється щомісяця за тарифами, які наведені <a href="https://www.dramox.tv/">тут</a>. Приєднуючись
          до Договору ви надаєте Dramox свою згоду на стягнення щомісячної абонентської плати.
        </p>
        <p>
          Dramox надає Користувачеві можливість тестувати Онлайн-театр протягом обмеженого терміну без внесення платежу
          «Випробувальний період».
        </p>
        <p>
          Випробувальний період доступний лише один раз для кожного окремого Користувача, і Користувач зобов’язаний
          сплатити абонентську плату після його закінчення; в протилежному випадку Dramox відмовиться від подальшого
          безкоштовного надання Послуг і зробить Твори недоступними для Користувача.
        </p>
        <p>
          Якщо Користувач не відмовиться від отримання Послуг впродовж Випробувального періоду, його обліковий запис
          буде автоматично переведено на стандартний режим, і Dramox вимагатиме від Користувача оплату Послуг відповідно
          до чинних тарифів.
        </p>
        <p>
          Перший платіж абонентської плати буде здійснено в день укладення Договору або закінчення Випробувального
          періоду. Згодом абонентська плата за кожен наступний місяць буде сплачена наперед у той самий день місяця,
          коли Користувач і Dramox уклали Договір. Якщо такого дня у даному місяці немає, абонентська плата стягується в
          останній день календарного місяця.
        </p>
        <p>
          Якщо платіж не здійснено або якщо емітент картки відхиляє платіж, Dramox обмежить доступ Користувача до
          Послуг, доки платіж не буде здійснено. Dramox може розірвати Договір у разі затримки платежу понад 1 день.
        </p>
        <p>
          Послуга вважається наданою належним чином після закінчення строку, протягом якого вона є доступною до
          використання, незалежно від того, чи Користувач здійснював перегляд Творів.
        </p>
        <p>
          Dramox може змінювати розмір абонентської плати та інші умови надання Послуг в односторонньому порядку, але
          заздалегідь та з обов’язковим повідомлення Користувача про це. Користувач буде повідомлений про будь-які такі
          зміни на адресу електронної пошти, зазначену в його обліковому записі, не пізніше ніж за тридцять (30) днів до
          початку дії таких змін. Якщо Користувач не згоден зі змінами, він може розірвати Договір.
        </p>
        <h2>5. Подарункові сертифікати, ваучери</h2>
        <p>
          Оплата Послуг також може бути здійснена за допомогою ваучерів («Ваучер»). Кожен Ваучер містить унікальний код,
          який Користувач вводить у відповідне поле під час реєстрації свого облікового запису.
        </p>
        <p>
          Ваучери не використовуються з обліковими записами Користувачів, де зазначено, що оплата здійснюється карткою.
          В такому випадку необхідно створити новий обліковий запис або скасувати існуючий і створити новий,
          використовуючи ту саму адресу електронної пошти.
        </p>
        <p>
          Якщо код, зазначений у Ваучері, не працює, Користувач може зв’язатися з Dramox в будь-який час; Dramox
          перевірить заявлений код та відправить Користувачеві оновлену інформацію.
        </p>
        <p>Строк дії Ваучера становить 1 рік з дати випуску.</p>
        <p>
          Ваучери можна придбати на Вебсайті. Якщо Користувач купує Ваучер на подарунок, він отримає електронний лист із
          посиланням, за яким потім можна буде завантажити Ваучер в електронному вигляді, роздрукувати його або
          переслати одержувачу подарунка. Ваучери не призначені для перепродажу. Перепродаж Ваучерів заборонений і
          вважається істотним порушенням Умов.
        </p>
        <p>Dramox пропонує Ваучери різної вартості та строків підписки. Актуальна пропозиція доступна на Вебсайті.</p>
        <p>
          Після введення коду в систему Ваучер не підлягає поверненню і Користувач втрачає право на його відкликання.
        </p>
        <p>
          Ваучери також можуть придбати юридичні особи, зокрема, як подарунки своїм співробітникам або клієнтам. Також
          для шкіл та соціальних закладів діє спеціальна пропозиція на замовлення Ваучерів. Для придбання більшої
          кількості Ваучерів рекомендуємо звертатися за адресою{' '}
          <a href="mailto:olia.shylo@dramox.tv">olia.shylo@dramox.tv</a>.
        </p>
        <p>
          Оскільки емітентом таких Ваучерів може бути лише Dramox, отже, Dramox не несе відповідальності за несправності
          або інші збитки, пов'язані з ваучерами, придбаними за межами нашого Вебсайту або нашого відділу продажів.
        </p>
        <h2>6. Особистий кабінет</h2>
        <p>
          Користувач реєструється на Вебсайті у розділі «Реєстрація». Для реєстрації необхідно заповнити необхідні
          ідентифікаційні дані та відомості про спосіб оплати.
        </p>
        <p>Під час реєстрації Dramox автоматично перевірить вашу IP-адресу.</p>
        <p>
          Користувач погоджується надати точну інформацію при реєстрації та оновлювати цю інформацію без зайвих затримок
          у разі будь-яких змін.
        </p>
        <p>
          Під час реєстрації Користувачу буде запропоновано ввести такі дані: логін, ім'я, прізвище, адресу електронної
          пошти, пароль, дані щодо обраного способу оплати та інші дані, які можуть бути необхідні в процесі надання
          Послуг. Доступ до особистого кабінету є персоналізованим та не передбачає можливості його використання
          сторонніми особами. Якщо Dramox помітить, що дані облікового запису було використано неправильно, Dramox може
          відмовитися від надання будь-яких подальших Послуг, а також може заблокувати або видалити обліковий запис
          Користувача та негайно припинити дію Договору.
        </p>
        <p>
          Dramox може попросити Користувача змінити пароль, якщо він не відповідає правилам безпеки та якщо існує ризик
          його неправильного використання.
        </p>
        <p>Внаслідок припинення дії облікового запису Користувач втрачає право на надання Послуг.</p>
        <h2>7. Інтелектуальна власність та ліцензійні умови</h2>
        <p>
          Всі результати інтелектуальної діяльності, що розміщені та використовуються в Онлайн-театрі, зокрема Твори, є
          інтелектуальною власністю їх законних правовласників і охороняються законодавством про інтелектуальну
          власність, а також відповідними міжнародними угодами і конвенціями.{' '}
        </p>
        <p>Користувач може використовувати Сервіс виключно для своїх власних потреб, відповідно до цих Умов.</p>
        <p>
          Будь-яке використання Послуг, Онлайн-театру або результатів інтелектуальної діяльності, розміщених у ньому,
          крім дозволеного в Договорі, категорично забороняється.
        </p>
        <p>
          Користувач не має права використовувати будь-які результати інтелектуальної діяльності, розміщені в
          Онлайн-театрі для публічного виробництва, робити копії, качати, відтворювати, видозмінювати, передавати,
          продавати, транслювати, поширювати, змінювати або чи іншим чином їх використовувати. Крім того забороняється
          обходити, змінювати, видаляти, або іншим чином впливати на безпеку Онлайн-театру, програмне забезпечення та
          інші елементи, якщо це може спричинити порушення норм законодавства та/або цих Умов.
        </p>
        <p>Dramox надає Користувачеві невиключну, невідчужувану та обмежену ліцензію на перегляд Творів.</p>
        <p>Будь-яке порушення умов цього розділу є підставою для притягнення до відповідальності.</p>
        <h2>8. Припинення Договору, відмова від Послуг, повернення коштів</h2>
        <p>
          Укладаючи Договір, Користувач прямо дає свою згоду на надання Послуг одразу після укладання Договору та оплати
          абонентської плати. Користувач цим визнає, що, оскільки він отримує доступ до Послуг до закінчення
          чотирнадцятиденного (14-денного) терміну для відмови від Договору, Користувач втрачає право відмовитися від
          Договору впродовж чотирнадцяти (14) днів після його виконання.
        </p>
        <p>
          Ця стаття жодним чином не порушує прав Користувача в частині розірвання Договору, оскільки Користувач має таке
          право впродовж дії Випробувального періоду дії підписки.
        </p>
        <p>
          Договір укладається на період підписки в один (1) місяць і буде автоматично продовжуватися на один (1) місяць,
          доки Користувач або Dramox не розірве Договір відповідно до цих Умов.
        </p>
        <p>
          Якщо Користувач бажає розірвати Договір, він повинен повідомити про це Dramox у розділі користувача Вебсайту і
          Договір буде припинено в кінці поточного календарного місяця передоплати.
        </p>
        <p>
          Dramox може розірвати Договір, якщо: Користувач затримує оплату не менше ніж на 1 день; Користувач неправильно
          використовує Випробувальний період або порушує його умови; Користувач неправомірно отримує Послуги або є
          обґрунтована підозра у несанкціонованому використанні; Користувач намагався використати Випробувальний період
          більше одного разу (1x); або Користувач істотно порушує ці Умови.
        </p>
        <h2>9. Відповідальність</h2>
        <p>
          Користувач має право на пропорційне зменшення абонентської плати, за його ініціативою, у разі несправностей,
          відключень та інших недоліків, внаслідок яких неможливо користуватися Послугами протягом безперервного
          періоду, що перевищує 24 години, і що викликано причинами з боку Dramox.
        </p>
        <p>
          Користувач не має права на компенсацію за перерви, відключення або інші недоліки Послуг, що виникли внаслідок
          технічного обслуговування. Технічне обслуговування проводиться один раз на календарний місяць з 00:00 до 8:00
          ранку. Під час технічного обслуговування Сервіс може бути недоступним.
        </p>
        <p>
          Користувач зобов’язаний відшкодувати Dramox або звільнити Dramox від відповідальності за будь-які збитки,
          витрати або претензії, що виникли у зв’язку з порушенням умов Договору, порушенням чинного законодавства або
          порушенням прав третіх сторін з боку Користувача.
        </p>
        <h2>10. Інші умови</h2>
        <p>
          Dramox може передати свої права та обов’язки, що випливають з Договору, третім особам. Користувач не може
          передавати свої права та обов'язки, що випливають з Договору.
        </p>
        <p>
          Вебсайт Dramox може містити посилання на інші вебсайти, якими керують треті сторони. Dramox не контролює вміст
          таких вебсайтів і не несе за них відповідальності. Користувач використовує такі вебсайти на власний ризик.
        </p>
        <h2>11. Застосовне право та вирішення спорів</h2>
        <p>
          У разі виникнення спірних ситуацій між Користувачем і Dramox, Користувач може зв’язатися з Dramox,
          використовуючи контактні дані, зазначені в кінці цих Умов, або інші контактні дані, доступні на Вебсайті.
        </p>
        <p>
          Користувач і Dramox зобов’язуються спробувати врегулювати спірну ситуацію мирним шляхом. У разі недосягнення
          згоди, спір буде вирішуватися чеським судом, який має відповідну юрисдикцію.
        </p>
        <p>Цей Договір та відносини між Користувачем та Dramox регулюються законодавством Чеської Республіки.</p>
        <p>
          Якщо мирне врегулювання спору між Користувачем і Dramox не може бути досягнуто, Користувач може подати скаргу
          до Торгової інспекції Чехії, як органу, уповноваженого розглядати скарги та сприяти вирішенню спорів
          споживачів у позасудовому порядку, або скористатися опцією вирішення спорів, до подання позову.
        </p>
        <p>Щодо змісту Послуг, Користувач також може подати скаргу до Ради з питань радіо і телебачення.</p>
        <h2>12. Контактні дані Виконавця</h2>
        <p>
          Dramox є власником та адміністратором Сервісу. Користувач може зв’язатися з Dramox, використовуючи наступні
          контактні дані:
        </p>

        <address>
          Dramox s.r.o.
          <br />
          Bucharova 2928/14a, Stodůlky, 158 00 Prague 5, Aspira Business Centre,
          <br />
          Czech Republic
        </address>

        <p>
          <a href="mailto:pidtrymka@dramox.tv">pidtrymka@dramox.tv</a>
        </p>
      </>
    ),
    [],
  );

  const plTerms = useCallback(() => {
    return (
      <>
        <p>Data aktualizacji: 1.11.2022</p>
        <h1>Regulamin Platformy DRAMOX</h1>
        <h2>Postanowienia ogólne</h2>
        <ul>
          <li>
            Dramox s.r.o., spółka z siedzibą w Pradze, pod adresem Bucharova 2928/14a, Stodůlky, 158 00 Praga 5, Aspira
            Business Centre, zarejestrowana w Rejestrze Handlowym prowadzonym przez Sąd Miejski w Pradze, sekcja C, plik
            332337 („Dramox”), świadczy audiowizualne usługi medialne na żądanie pod nazwą Dramox na portalu znajdującym
            się pod adresem: dramox.pl lub w aplikacji stworzonej przez Dramox dostępnej w następujący sposób: jako
            aplikacja mobilna Android, iOS, aplikacja smart TV LG oraz Samsung - tj. oprogramowanie umożliwiające dostęp
            do materiałów za pośrednictwem urządzeń przenośnych (np. tabletu, telefonu komórkowego) lub telewizorów
            (&bdquo;
            <strong>Portal</strong>&ldquo;) z treściami na żądanie dostępnymi w Internecie (&bdquo;
            <strong>Usługi</strong>&ldquo;).
          </li>
          <li>
            Regulamin ma zastosowanie do umów o świadczenie Usług pomiędzy Dramox a użytkownikiem, jako osobą fizyczną
            oraz pomiędzy Dramox a osobami prawnymi i/lub instytucjami, jeżeli stosowne umowy zostaną zawarte zgodnie z
            Regulaminem. Umowę o świadczenie Usług z Dramox mogą zawrzeć wyłącznie osoby, które ukończyły 18 lat i mają
            stałe miejsce zamieszkania na terytorium Polski; osoby poniżej 18 roku życia mogą to zrobić wyłącznie za
            pośrednictwem swoich przedstawicieli ustawowych (&bdquo;<strong>Użytkownik</strong>&ldquo;). Dramox może
            odmówić zawarcia umowy z Użytkownikiem lub rozwiązać umowę z Użytkownikiem ze skutkiem natychmiastowym w
            przypadku naruszenia przez Użytkownika Regulaminu.
          </li>

          <li>
            W związku z powyższym, jako Użytkownika należy rozumieć zarówno konsumenta – osobę fizyczną, dla której
            zawarcie umowy o świadczenie usługi elektronicznej lub Umowy nie jest związane bezpośrednio z jej
            działalnością gospodarczą lub zawodową oraz przedsiębiorcę na prawach konsumenta – osobę fizyczną
            zawierająca umowę bezpośrednio związaną z jej działalnością gospodarczą, gdy z treści tej umowy wynika, że
            nie posiada ona dla niej charakteru zawodowego, wynikającego w szczególności z przedmiotu wykonywanej przez
            nią działalności gospodarczej, udostępnionego na podstawie przepisów o Centralnej Ewidencji i Informacji o
            Działalności Gospodarczej.
          </li>

          <li>
            Regulamin jest wiążący dla Dramox i Użytkowników, i wraz z innymi dokumentami (cennik, warunki płatności,
            oferty specjalne, treść zgód i innych oświadczeń wyrażonych przez Użytkownika itp.) stanowią łącznie umowę o
            świadczenie Usług (&bdquo;<strong>Umowa</strong>&ldquo;). Umowa jest zawierana na odległość drogą
            elektroniczną między Dramox i Użytkownikiem.
          </li>

          <li>
            Użytkownik zgadza się zapłacić Dramox opłatę abonamentową za świadczone Usługi zgodnie z obowiązującym
            cennikiem lub innymi stosownymi dokumentami zaakceptowanymi przez Użytkownika i dostępnymi w ramach Portalu.
            Regulamin określa również zasady i warunki świadczenia usług drogą elektroniczną. W celu korzystania z
            Usług, Użytkownik zobowiązany jest do akceptacji Regulaminu w sposób opisany poniżej.
          </li>
          <li>
            Po zamówieniu Usług, Dramox wyśle ​​potwierdzenie Użytkownikowi na adres e-mail Użytkownika podany przez
            Użytkownika podczas rejestracji, potwierdzając tym samym zawarcie Umowy. Potwierdzenie e-mail będzie
            zawierać m.in. odesłanie do Regulaminu. Umowa pomiędzy Użytkownikiem a Dramox zostaje zawarta po wypełnieniu
            przez Użytkownika wszystkich wymaganych danych rejestracyjnych i kliknięciu przycisku „Potwierdź” oraz
            akceptacji Regulaminu. Umowa stanowi umowę zawartą drogą elektroniczną i zostanie zarchiwizowana przez
            Dramox.
          </li>
          <li>
            Regulamin jest stale i nieodpłatnie dostępny{' '}
            <AppLink href={Permalink.termsAndConditions(locale)}>
              <a>tutaj</a>
            </AppLink>
            .
          </li>
          <li>
            Regulamin stanowi regulamin, o którym mowa w art. 8 Ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą
            elektroniczną (t.j. Dz. U. z 2020 r. poz. 344).
          </li>
          <li>
            Ogłoszenia, cenniki i inne informacje o produktach publikowane na Platformie nie stanowią oferty w
            rozumieniu ustawy z dnia 23 kwietnia 1964 r. Kodeks cywilny (t.j. Dz. U. z 2022 r. poz. 1360 z późn. zm.)
            (&bdquo;<strong>Kodeks cywilny</strong>&ldquo;), a jedynie zaproszenie do zawarcia umowy sprzedaży.
          </li>
        </ul>

        <h2>Przetwarzanie danych osobowych</h2>
        <p>
          Użytkownik przyjmuje do wiadomości, że jego dane osobowe są przetwarzane w ramach świadczenia Usług przez
          Dramox jako administratora danych osobowych. Dramox wywiązuje się z obowiązku informacyjnego wobec Użytkownika
          w rozumieniu art. 13 Rozporządzenia Parlamentu Europejskiego i Rady 2016/679 w sprawie ochrony osób fizycznych
          w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych, oraz uchylenia
          dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (&bdquo;<strong>RODO</strong>&ldquo;) – zgodnie z
          zasadami określonymi w Polityce Prywatności znajdującej się{' '}
          <AppLink href={Permalink.privacyPolicy(locale)}>
            <a>tutaj</a>
          </AppLink>
          .
        </p>

        <h2>Ograniczenia w świadczeniu Usług</h2>
        <ul>
          <li>
            Usługi są przeznaczone głównie do użytku na terytorium Polski oraz Unii Europejskiej. Użytkownik może
            korzystać z Usług poza terytorium Polski będąc czasowo obecny na terytorium państw członkowskich
            Europejskiego Obszaru Gospodarczego zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady 2017/1128 w
            sprawie transgranicznego przenoszenia usług treści na rynku wewnętrznym (niniejsze zezwolenie na tymczasowe
            korzystanie dotyczy państw członkowskich UE, Islandii, Liechtensteinu i Norwegii). Dramox niniejszym
            zastrzega, że dostępność określonych materiałów i Usług oraz ich jakość mogą różnić się w zależności od
            lokalizacji Użytkownika.
          </li>
          <li>
            W związku z czasową autoryzacją do oglądania treści poza Polską Dramox automatycznie weryfikuje, czy adres
            IP Użytkownika znajduje się na terytorium Europejskiego Obszaru Gospodarczego. W przypadku braku możliwości
            uzyskania tych informacji lub korzystania przez Użytkownika z oprogramowania w celu obejścia identyfikacji
            adresu IP (tworzenie sieci VPN itp.), Dramox może odmówić świadczenia Usług.
          </li>
          <li>
            Usługi świadczone przez Dramox obejmują w szczególności udostępnianie nagrań spektakli teatralnych i innych
            utworów audiowizualnych, które znajdują się w ofercie Dramox według własnego uznania, a Użytkownikowi nie
            przysługują żadne prawa do treści i materiałów zamieszczanych na Platformie. Użytkownik może oglądać treści
            udostępniane w bazie Dramox po zawarciu Umowy, zgodnie z warunkami wskazanymi w Regulaminie. Przegląd
            zawartości Usług jest dostępny na Portalu.
          </li>
          <li>
            Wszelkie zmiany treści i zakresu oferowanych materiałów w ramach Portalu nie stanowią zmiany Umowy pomiędzy
            Dramox a Użytkownikiem. Użytkownik przyjmuje do wiadomości, że oferta treści zamieszczanych na Portalu może
            być kształtowana według uznania Dramox oraz zgodnie ze stosownymi umowami lub porozumienia zawartych z
            właścicielami praw autorskich do utworów umieszczanych na Portalu.
          </li>
          <li>
            Usługi świadczone przez Dramox mogą zawierać nagrania, które mogą zostać uznane za nieodpowiednie dla dzieci
            i młodzieży oraz które mogą być postrzegane przez inne osoby jako nieprzyzwoite lub niepokojące. W takich
            przypadkach w nagraniu zostanie prawidłowo wyświetlony limit wiekowy dostępu do danej treści. W związku z
            tym, że Usługi przeznaczone są przede wszystkim dla osób powyżej 18 roku życia, znak ten ma charakter
            wyłącznie orientacyjny i Dramox nie ponosi odpowiedzialności za udostępnienie przez Użytkownika treści w ten
            sposób oznaczonych osobom niepełnoletnim. Użytkownik ponosi pełną odpowiedzialność za ustalenie, czy
            jakakolwiek konkretna treść Usług jest odpowiednia dla dzieci i młodzieży oraz komu wskazane treści zostaną
            udostępnione.
          </li>
        </ul>

        <h2>Newsletter</h2>
        <ol>
          <li>
            W ramach świadczenia Usług Użytkownik może otrzymywać za pośrednictwem poczty elektronicznej bieżące
            informacje na temat Portalu oraz działalności Dramox („Newsletter”) – zgodnie z zasadami określonymi w
            Polityce Prywatności portalu.
          </li>
          <li>
            Rezygnacja z usługi Newsletter wymaga wyboru odpowiedniej opcji na końcu wiadomości (wysłanej jako
            Newsletter) lub poprzez kontakt pod adresem: <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>.
          </li>
        </ol>

        <h2>Ceny Usług</h2>
        <ul>
          <li>
            Użytkownik, w przypadku chęci korzystania z Usług, zobowiązuje się do uiszczenia na rzecz Dramox opłaty za
            korzystanie z Usług w formie miesięcznej opłaty abonamentowej na podstawie obowiązującego cennika, który
            jest dostępny pod adresem: dramox.pl oraz{' '}
            <AppLink href={Permalink.voucher(locale)}>
              <a>cennik voucherów</a>
            </AppLink>{' '}
            – zgodnie z ofertą wskazaną przez Dramox.
          </li>
          <li>
            Dramox umożliwi Użytkownikowi testowanie Usług przez ograniczony czas bez obowiązku uiszczenia opłaty w
            „Okresie próbnym”. Okres próbny jest dostępny dla każdego Użytkownika tylko raz, a po jego upływie
            Użytkownik jest zobowiązany do uiszczenia opłaty abonamentowej; w przeciwnym razie Dramox odmówi dalszego
            korzystania z Usług nieodpłatnie i uniemożliwi Użytkownikowi dostęp do treści. Okres próbny trwa 7 dni
            liczonych od momentu rejestracji Użytkownika i wyboru przez Użytkownika opcji korzystania z Okresu próbnego.
          </li>
          <li>
            O ile Użytkownik nie zrezygnuje z Usług w Okresie Próbnym, jego konto Użytkownika zostanie automatycznie
            przeniesione do standardowego trybu, a Dramox zażąda od Użytkownika zapłaty za Usługi zgodnie z
            obowiązującym cennikiem.{' '}
          </li>
          <li>
            Pierwsza opłata abonamentowa zostanie dokonana w dniu zawarcia Umowy przez Użytkownika lub wygaśnięcia
            Okresu Próbnego. Następnie, opłaty abonamentowe za każdy kolejny miesiąc będą uiszczane z góry w tym samym
            dniu kolejnego miesiąca, w którym Użytkownik i Dramox zawarli Umowę. W przypadku braku takiego dnia w danym
            miesiącu opłata abonamentowa zostanie naliczona ostatniego dnia danego miesiąca kalendarzowego.
          </li>
          <li>
            Jeśli płatność nie zostanie dokonana lub jeśli wystawca karty odrzuci płatność, Dramox ograniczy dostęp do
            Usług do czasu dokonania płatności przez Użytkownika. Dramox może rozwiązać Umowę w przypadku opóźnienia w
            płatności przekraczającego 1 dzień.
          </li>
        </ul>

        <h2>Vouchery</h2>
        <ul>
          <li>
            Opłatę za korzystanie z Usług można również uiścić za pomocą voucherów. Każdy voucher zawiera unikalny kod
            do wpisania przez Użytkownika w odpowiednim polu podczas rejestracji nowego konta Użytkownika.
          </li>
          <li>
            Voucherów nie można używać w przypadku kont Użytkowników, dla których wybrano płatność kartą. W takim
            przypadku konieczne jest założenie nowego konta lub zlikwidowanie istniejącego konta i założenie nowego
            konta z wykorzystaniem tego samego adresu e-mail, na który zostanie dokonana płatność za pomocą vouchera.
          </li>
          <li>
            Jeśli kod określony w voucherze nie działa, Użytkownik może skontaktować się z Dramox w dowolnym momencie;
            Dramox zweryfikuje poprawność żądanego kodu i wyśle ​nowy kod do Użytkownika, jeżeli będzie to zasadne.
          </li>
          <li>Voucher jest ważny w ciągu roku od jego zakupu.</li>
          <li>
            Vouchery można kupić na Portalu{' '}
            <AppLink href={Permalink.voucher(locale)}>
              <a>TUTAJ</a>
            </AppLink>
            . W przypadku zakupu przez Użytkownika vouchera m.in. w prezencie dla osoby trzeciej, Użytkownik otrzyma
            wiadomość e-mail z linkiem, za pomocą którego będzie mógł pobrać voucher, wydrukować go lub przekazać
            odbiorcy prezentu. Kupony nie są przeznaczone do odsprzedaży. Odsprzedaż kuponów jest zabroniona i jest
            uważana za istotne naruszenie Regulaminu.
          </li>
          <li>
            Oferowane są vouchery o różnej wartości i okresach subskrypcji. Aktualna oferta dostępna jest na Portalu{' '}
            <AppLink href={Permalink.voucher(locale)}>
              <a>TUTAJ</a>
            </AppLink>
          </li>
          <li>
            Po wprowadzeniu kodu do systemu w ramach Portalu, voucher nie podlega zwrotowi i podlega zasadom odnoszącym
            się do opisanego w sekcji „Prawo odstąpienia od Umowy” Regulaminu.
          </li>
          <li>
            Vouchery mogą nabyć również podmioty komercyjne, m.in. jako prezenty dla swoich pracowników lub klientów.
            Vouchery można również zamówić w specjalnym reżimie dla szkół i placówek socjalnych. W przypadku zakupu
            większej liczby voucherów zalecamy kontakt z działem sprzedaży Dramox bezpośrednio pod adresem{' '}
            <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>
          </li>
          <li>
            Vouchery na subskrypcję Usług są wydawane wyłącznie przez Dramox i dlatego Dramox nie ponosi
            odpowiedzialności za nieprawidłowe działanie lub inne szkody w związku z voucherami zakupionymi poza
            Portalem lub naszym działem sprzedaży.
          </li>
        </ul>

        <h2>Warunki korzystania z Usług</h2>
        <ul>
          <li>
            W celu zapewnienia płynnego korzystania z Usług konieczne jest posiadanie przez zarejestrowanego Użytkownika
            urządzenia spełniającego minimalne wymagania techniczne i podłączonego do sieci Internet.
          </li>
          <li>
            Zalecamy weryfikację parametrów połączenia internetowego, w szczególności minimalnej prędkości, która nie
            powinna być niższa niż 2 Mb/s, a także ewentualnych ograniczeń ilości pobieranych danych.
          </li>
          <li>
            Oglądanie treści w ramach Portalu jest wymagające pod względem ilości pobieranych danych i dlatego nie
            nadaje się do połączeń, które są w jakikolwiek sposób ograniczone pod tym względem. Dramox nie ponosi
            odpowiedzialności za jakiekolwiek opłaty związane z ilością pobieranych danych, które mogą być pobierane
            przez niektórych dostawców usług internetowych.
          </li>
          <li>
            Zgodnie z obowiązującymi przepisami prawa, Dramox nie ponosi odpowiedzialności za niemożność korzystania z
            Usług przez Użytkownika lub ograniczony dostęp do Usług z powodu przeciążenia łącza internetowego lub w
            wyniku błędu lub problemów dotyczących sprzętu, sieci, elektroniki lub komunikacji poza kontrolą Dramox.
            Dramox nie ponowi również odpowiedzialności za niemożność korzystania z Usług ze względu na działanie siły
            wyższej.
          </li>
        </ul>

        <h2>Konto Użytkownika</h2>
        <ul>
          <li>
            Użytkownik rejestruje się na Portalu (w ramach strony dramox.pl) w sekcji „Rejestracja”. W celu dokonania
            rejestracji należy:
            <ul>
              <li>podać wymagane dane identyfikacyjne;</li>
              <li>
                podać dane dotyczące sposobu płatności, która może być dokonana tylko kartami płatniczymi (kredytowymi,
                debetowymi) akceptowanymi na terytorium Rzeczypospolitej Polskiej. W celu przeprocesowania rejestracji
                Użytkownik zobowiązany jest podać wymagane dane niezbędne do przeprocesowania płatności w ramach
                subskrypcji – tj. cyklicznie odnawialnych płatności dokonywanych za pośrednictwem karty płatniczej.{' '}
              </li>
            </ul>
          </li>
          <li>W momencie rejestracji Dramox automatycznie zweryfikuje adres IP zgodnie postanowieniami Regulaminu.</li>
          <li>
            Użytkownik zgadza się podać aktualne i dokładne informacje podczas rejestracji i aktualizować te informacje
            bez zbędnej zwłoki w przypadku jakiejkolwiek zmiany.
          </li>
          <li>
            Rejestracja nie jest możliwa w aplikacji mobilnej ani przy wykorzystaniu aplikacji smart TV, a jedynie w
            zakładce „Rejestracja” na stronie dramox.pl.
          </li>
          <li>
            Dramox używa bramki płatniczej Stripe do przetwarzania płatności; przetwarzanie płatności podlega
            regulaminowi Stripe, który jest dostępny dla Użytkownika{' '}
            <a href="https://stripe.com/en-cz/privacy">TUTAJ</a>.
          </li>
          <li>
            W ramach rejestracji nowego użytkownika Użytkownik zostanie poproszony o podanie następujących danych:
            login, imię, nazwisko, adres e-mail, hasło, dane dotyczące wybranego sposobu płatności oraz inne dane, które
            mogą być wymagane i niezbędne do rejestracji. Login Użytkownika jest osobisty i nie może być używany przez
            osoby trzecie. Jeśli Dramox stwierdzi, że login został niewłaściwie użyty, Dramox może odmówić świadczenia
            jakichkolwiek dalszych Usług i może zablokować lub usunąć konto użytkownika oraz rozwiązać Umowę z
            Użytkownikiem ze skutkiem natychmiastowym.
          </li>
          <li>
            Dramox może zażądać od Użytkownika zmiany hasła, jeśli nie spełnia ono zasad bezpieczeństwa i istnieje
            ryzyko jego niewłaściwego użycia.
          </li>
          <li>
            W przypadku, gdy Użytkownik zapomni hasła dostępu do konta lub chce zmienić dotychczasowe hasło, powinien
            wysłać wiadomość poprzez formularz zamieszczony na stronie logowania Portalu, podając adres-mail, którym
            posłużył się podczas zakładania konta. Na podany przez Użytkownika adres e-mail zostanie wysłana wiadomość z
            wygenerowanym linkiem do zmiany hasła.
          </li>
          <li>
            Użytkownik może posiadać tylko jedno konto w ramach Portalu. Użytkownik uprawniony jest do korzystania
            jednocześnie z 1 urządzeń w ramach korzystania z Portalu.
          </li>
          <li>
            Użytkownik, który dokonał rejestracji może w każdej chwili usunąć konto samodzielnie lub zgłosić Dramox
            żądanie usunięcia Konta za pośrednictwem poczty elektronicznej na adres e-mail:{' '}
            <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>
          </li>
          <li>
            W przypadku usunięcia przez Użytkownika konta w Portalu, automatycznie zostaną usunięte wszelkie informacje
            dotyczące Użytkownika zgromadzone w ramach Portalu. Usunięcie konta uniemożliwia korzystanie z Usług, a
            późniejsze ponowne zarejestrowanie konta nie pozwala na odzyskanie takiej możliwości w ramach poprzedniej
            rejestracji.
          </li>
        </ul>

        <h2>Warunki korzystania z licencji w ramach świadczenia Usług</h2>
        <ul>
          <li>
            Użytkownik może korzystać z Usług zgodnie z własnymi potrzebami – tj. do użytku osobistego i niekomercyjnego
            oraz zgodnie z Regulaminem. Użytkownik nie jest uprawniony do korzystania z Usług w celach komercyjnych lub
            produkcji publicznej, wykonywania kopii/reprodukcji, wypożyczania, sprzedawania, nadawania lub innego
            rozpowszechniania, zmieniania, przekazywania lub w inny sposób modyfikowania treści materiałów lub utworów
            udostępnianych w ramach świadczenia Usług. Użytkownik nie jest upoważniony do obchodzenia, modyfikowania,
            usuwania, zmieniania lub w inny sposób manipulowania zabezpieczeniami, szyfrowaniem lub inną technologią lub
            oprogramowaniem będącym częścią Usług. Użytkownik nie może również w inny sposób korzystać z Usług w sposób
            niezgodny z prawami autorskimi, innymi prawami lub Regulaminem, a także dobrymi obyczajami. W przypadku
            naruszenia tego rodzaju Dramox zastrzega sobie prawo do wypowiedzenia Umowy Użytkownikowi ze skutkiem
            natychmiastowym.{' '}
          </li>
          <li>
            W związku z realizacją Umowy Dramox udziela Użytkownikowi niewyłącznej, nieprzenoszalnej i ograniczonej
            licencji na oglądanie treści udostępnianych w ramach świadczonych Usług. Użytkownik może korzystać z Usług i
            ich zawartości wyłącznie zgodnie z Umową, Regulaminem i w celach prywatnych, niekomercyjnych, zgodnie z
            obowiązującymi przepisami oraz dobrymi obyczajami.{' '}
          </li>
          <li>
            Materiały zamieszczone na Portalu oraz treść Usług są chronione prawem autorskim i innymi przepisami
            dotyczącymi ochrony własności intelektualnej. Umowa w żadnym wypadku nie ustanawia przeniesienia na
            Użytkownika tytułu własności lub jakiegokolwiek innego prawa własności intelektualnej do materiałów lub
            treści zamieszczonych na Portalu.
          </li>
          <li>
            Naruszenie niniejszego postanowienia Regulaminu będzie uważane za istotne naruszenie Umowy, a w przypadku
            stwierdzenia takiego naruszenia Dramox może natychmiast rozwiązać Umowę z Użytkownikiem i jednocześnie
            skorzystać ze wszystkich dostępnych środków prawnych w celu ochrony swoich praw i prawa posiadaczy praw
            autorskich do nagrań stanowiących zawartość Usług Dramox.
          </li>
        </ul>
        <p>
          Dramox jednocześnie zastrzega, że jakość oferowanych Usług (w tym jakość obrazu, dźwięku, szybkość odtwarzania
          materiałów itp.) może różnić się w zależności od urządzenia, jego parametrów, lokalizacji, szybkość łączą
          internetowego oraz innych czynników, które są niezależne od Dramox. Użytkownik ponosi odpowiedzialność za
          jakość i rodzaj urządzeń wykorzystywanych do korzystania z Portalu, a także za odpowiedni dostęp do Internetu.
          W celu właściwego korzystania z Portalu, Użytkownik zobowiązany jest do stałego aktualizowania oprogramowania
          urządzenia oraz korzystania z komputera lub urządzenia mobilnego, które jest kompatybilne z Portalem.{' '}
        </p>

        <h2>Zmiany Umowy</h2>
        <p>
          Dramox może zmienić wysokość opłaty abonamentowej i inne warunki korzystania z Usług według własnego uznania,
          ale zawsze z odpowiednim wyprzedzeniem. Użytkownik zostanie poinformowany o wszelkich takich zmianach na adres
          e-mail podany na koncie Użytkownika nie później niż trzydzieści (30) dni przed datą wejścia w życie zmiany.
          Jeżeli Użytkownik nie zgadza się na zmiany, może wypowiedzieć Umowę ze skutkiem na dzień wejścia w życie danej
          zmiany.
        </p>

        <h2>Prawo odstąpienia od Umowy</h2>
        <ul>
          <li>
            Prawo odstąpienia od Umowy przysługuje Użytkownikowi, który zawiera Umowę jako konsument, czyli w celu
            niezwiązanym z prowadzoną przez siebie działalnością gospodarczą lub zawodową a Umowa zostałaby zawarta na
            odległość lub poza lokalem przedsiębiorstwa. Uprawnienie do odstąpienia od Umowy na tych samych zasadach co
            konsumentowi, przysługuje także innym podmiotom, do których z mocy prawa stosuje się art. 221 Kodeksu
            cywilnego.
          </li>
          <li>
            Użytkownik, o którym mowa powyżej, może odstąpić od Umowy dotyczącej Usługi w terminie 14 dni od jej
            zawarcia.
          </li>
          <li>
            Odstąpienia od Umowy Użytkownik dokonuje przez przesłanie oświadczenia o odstąpieniu od Umowy na piśmie lub
            drogą elektroniczną na adres Dramox wskazany w Regulaminie. Wzór oświadczenia stanowi załącznik do
            Regulaminu.
          </li>
          <li>
            W przypadku jednak zawarcia Umowy i uzyskania dostępu do Portalu, Użytkownik wyraźnie wyraża zgodę na
            świadczenie Usług niezwłocznie po zawarciu Umowy i uiszczeniu opłaty abonamentowej wynikającej z Umowy.
            Użytkownik przyjmuje do wiadomości, że z uwagi na uzyskanie przez Użytkownika dostępu do Usług przed upływem
            czternastodniowego (14-dniowego) terminu na odstąpienie od Umowy, Użytkownik traci prawo do odstąpienia od
            Umowy w terminie czternastu (14) dni od dnia ich wykonanie zgodnie z przepisami Kodeksu cywilnego i innych
            obowiązujących przepisów.
          </li>
          <li>
            Niniejsze postanowienie w żaden sposób nie narusza prawa Użytkownika do rozwiązania Umowy w dowolnym
            momencie w Okresie Próbnym bez obowiązku uiszczenia opłaty abonamentowej.
          </li>
        </ul>

        <h2>Czas trwania Umowy</h2>
        <ul>
          <li>
            Umowa jest zawierana każdorazowo na okres abonamentowy jednego (1) miesiąca i będzie automatycznie
            wielokrotnie przedłużana o okresy jednego (1) miesiąca do momentu rozwiązania Umowy przez Użytkownika lub
            Dramox zgodnie z Regulaminem.
          </li>
          <li>
            Jeśli Użytkownik chce rozwiązać Umowę, musi powiadomić o tym Dramox w sekcji użytkownika Portalu, a Umowa
            wygaśnie z końcem bieżącego miesiąca kalendarzowego opłaconego z góry. Użytkownik uprawniony jest do
            powiadomienia Dramox o chęci rozwiązania Umowy w każdym czasie obowiązywania abonamentu.
          </li>
          <li>
            Dramox może wypowiedzieć Umowę, jeżeli: Użytkownik zalega z płatnością przez okres co najmniej 1 dnia;
            Użytkownik nadużywa Okresu Próbnego lub narusza jego warunki; z Usług korzysta Użytkownik bez upoważnienia
            lub istnieje uzasadnione podejrzenie nieuprawnionego korzystania; Użytkownik próbował skorzystać z Okresu
            Próbnego więcej niż jeden raz; lub Użytkownik w istotny sposób naruszy Umowę lub wielokrotnie naruszył Umowę
            w jakikolwiek inny sposób.
          </li>
        </ul>

        <h2>Ograniczenie odpowiedzialności; Awarie Usług</h2>
        <ul>
          <li>
            W przypadku awarii, przestojów i innych usterek, w wyniku których nie jest możliwe korzystanie z Usług przez
            nieprzerwany czas przekraczający 24 godziny i które są spowodowane przyczynami leżącymi po stronie Dramox,
            Użytkownikowi – na jego życzenie - przysługuje prawo do proporcjonalnego obniżenia opłaty abonamentowej.
          </li>
          <li>
            Użytkownikowi nie przysługuje odszkodowanie za przerwy, przestoje lub inne usterki Usług wynikające z
            konserwacji. Konserwacja jest przeprowadzana raz w miesiącu kalendarzowym w godzinach od 00:00 do 8:00.
            Dramox zastrzega niniejszym, że Usługi mogą być niedostępne podczas konserwacji.
          </li>
        </ul>

        <h2>Odszkodowanie za szkody</h2>
        <p>
          W zakresie dopuszczalnym przez obowiązujące przepisy, Użytkownik jest zobowiązany zwolnić Dramox z
          odpowiedzialności za wszelkie roszczenia powstałe w wyniku lub w związku z naruszeniem Umowy, naruszeniem
          obowiązującego prawa lub naruszeniem praw osób trzecich przez Użytkownika.
        </p>

        <h2>Przeniesienie praw i obowiązków</h2>
        <p>
          Dramox może przenieść swoje prawa i obowiązki wynikające z Regulaminu na osobę trzecią, od której można
          zasadnie oczekiwać, że wykona swoje zobowiązania wobec Użytkownika w sposób prawidłowy i zgodny z Regulaminem.
          Użytkownik nie może dokonać cesji swoich praw i obowiązków wynikających z Regulaminu – bez uprzedniej pisemnej
          zgody Dramox.
        </p>

        <h2>Odniesienia do materiałów osób trzecich</h2>
        <p>
          Strona może zawierać łącza do innych witryn obsługiwanych przez osoby trzecie. Dramox nie ma kontroli nad
          takimi linkami lub zawartością takich stron internetowych i nie ponosi za nie odpowiedzialności. Użytkownik
          korzysta z takich stron internetowych na własne ryzyko.
        </p>

        <h2>Reklamacje</h2>
        <ol>
          <li>
            Reklamacje dotyczące Portalu oraz poszczególnych Usług mogą być zgłaszane przez Użytkownika na adres
            korespondencyjny Dramox oraz drogą elektroniczną na adres{' '}
            <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>.
          </li>
          <li>
            W reklamacji Użytkownik powinien wskazać jej przedmiot, w szczególności opisać Usługę, której reklamacja
            dotyczy, a także wszelkie okoliczności uzasadniające reklamację (w tym jej szczegółowy opis oraz żądanie
            Użytkownika) oraz przekazać swoje dane kontaktowe. Dramox może zwrócić się do Użytkownika o podanie
            dodatkowych informacji, niezbędnych do rozpatrzenia reklamacji.
          </li>
          <li>
            Reklamacje będą rozpatrywane przez Dramox niezwłocznie, nie dłużej niż w terminie 14 dni lub 30 dni (w
            przypadku spraw bardziej skomplikowanych) licząc od daty otrzymania reklamacji.{' '}
          </li>
          <li>
            Brak udzielenia odpowiedzi na reklamację w terminie 30 dni od dnia jej otrzymania uważa się za jej uznanie.{' '}
          </li>
          <li>
            W sytuacji, gdy reklamacja nie zawiera danych kontaktowych, które umożliwiałyby kontakt z Użytkownikiem,
            Dramox będzie uprawniony do pozostawienia reklamacji bez odpowiedzi.{' '}
          </li>
          <li>
            Wniesienie przez Użytkownika reklamacji, a także jej nieuznanie albo pozostawienie bez rozpoznania przez
            Dramox, nie ma wpływu na uprawnienie Użytkownika do dochodzenia roszczeń na drodze sądowej zgodnie z
            obowiązującymi przepisami prawa.{' '}
          </li>
          <li>
            Dramox zobowiązany jest dostarczyć Użytkownikowi Usługi bez wad. W przypadku jakichkolwiek wad świadczonych
            Usług, reklamacja będzie rozpatrywana zgodnie z powszechnie obowiązującymi przepisami w tym zakresie –
            biorąc pod uwagę status Użytkownika (tj. czy Użytkownik jest konsumentem lub przedsiębiorcą na prawach
            konsumenta).
          </li>
        </ol>

        <h2>Świadczenie usług drogą elektroniczną</h2>
        <ol>
          <li>
            W ramach Platformy Dramox świadczy nieodpłatnie na rzecz Użytkowników, na zasadach opisanych w niniejszym
            Regulaminie, usługi drogą elektroniczną w zakresie niezbędnym do świadczenia Usług.{' '}
          </li>
          <li>
            Przez usługi świadczone drogą elektroniczną na potrzeby świadczenia Usług należy rozumieć w szczególności
            takie usługi jak:
            <ul>
              <li>udostępnienie Regulaminu; </li>
              <li>udostępnienie możliwości założenia konta na Portalu;</li>
              <li>umożliwienie komunikacji pomiędzy Dramox i Użytkownikiem.</li>
            </ul>
          </li>
          <li>
            Umowa o świadczenie usług drogą elektroniczną zostaje zawarta z chwilą rejestracji Użytkownika na Portalu.
          </li>
          <li>
            Warunkiem technicznym niezbędnym do korzystania z Usług jest:
            <ol>
              <li>
                posiadanie zainstalowanej przeglądarki internetowej np.: Internet Explorer 9.0 (lub nowszej), Mozilla
                FireFox 14.0, Opera 14.0, Chrome 10.0;
              </li>
              <li>dostęp do Internetu;</li>
              <li>
                w przypadku aplikacji mobilnej lub smart TV – posiadanej odpowiedniej aplikacji lub funkcjonalności
                telewizora, a także odpowiedniego oprogramowania na urządzeniu mobilnym lub telewizorze;
              </li>
              <li>posiadanie adresu e-mail;</li>
              <li>posiadanie standardowego systemu operacyjnego.</li>
            </ol>
          </li>
          <li>
            Korzystanie z Usług może wiązać się z typowymi zagrożeniami po stronie Uczestnika, jako użytkownika
            Internetu. Ryzyko związane z korzystaniem z usług świadczonych drogą elektroniczną polega w szczególności na
            zagrożeniu zainfekowania systemu informatycznego Użytkownika oprogramowaniem mającym na celu np.
            szpiegowanie użytkowania, kradzież ważnych danych, spowodowanie braku możliwości uruchomienia systemu, spam,
            usuwanie danych itp.
          </li>
          <li>
            Dramox korzysta we własnym zakresie z zabezpieczeń systemowych i stałej pomocy informatycznej zapewniając
            bezpieczeństwo przesyłanych i odbieranych danych.
          </li>
          <li>
            Dramox nie odpowiada za ograniczenia w przepustowości łącz internetowych wykorzystywanych do korzystania z
            Portalu, utrudnienia związane z obciążeniem serwera oraz baz danych lub inne problemy techniczne, które
            mogłyby utrudnić korzystanie z Portalu lub też wydłużyć czas dostępu do Portalu i jego poszczególnych
            elementów.
          </li>
          <li>Umowa o świadczenie usług drogą elektroniczną zostaje zawarta na czas nieokreślony.</li>
        </ol>

        <h2>Rozwiązywanie sporów</h2>
        <ul>
          <li>
            W przypadku jakiegokolwiek sporu pomiędzy Użytkownikiem a Dramox, Użytkownik może skontaktować się z Dramox
            korzystając z danych kontaktowych podanych na końcu niniejszego Regulaminu lub innych danych kontaktowych
            dostępnych na Stronie.
          </li>
          <li>
            Użytkownik i Dramox będą dążyć do polubownego rozwiązywania sporów. Jeżeli nie uda się osiągnąć ugody, spór
            zostanie rozstrzygnięty przez właściwy sąd powszechny w Polsce. Użytkownik, który zawarł z Dramox Umowę jako
            konsument, czyli osoba fizyczna dokonująca z przedsiębiorcą czynności prawnej niezwiązanej bezpośrednio z
            jej działalnością gospodarczą lub zawodową, może korzystać z pozasądowej możliwości rozwiązywania sporów
            drogą elektroniczną za pośrednictwem platformy internetowej ODR Unii Europejskiej umożliwiającej składanie
            reklamacji i dochodzenie roszczeń związanych ze wskazaną Umową, która to platforma ODR Unii Europejskiej
            znajduje się na stronie: <a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a>
            .
          </li>
        </ul>

        <h2>Prawo właściwe</h2>
        <ul>
          <li>
            Regulamin nie ogranicza żadnych praw przysługujących Użytkownikom na podstawie bezwzględnie obowiązujących
            przepisów prawa.
          </li>
          <li>Regulamin oraz stosunki prawne pomiędzy Użytkownikiem a Dramox podlegają prawu polskiemu.</li>
          <li>
            Organem właściwym w sprawach audiowizualnych usług medialnych na żądanie jest Krajowa Rada Radiofonii i
            Telewizji: Krajowa Rada Radiofonii i Telewizji, z którą można kontaktować się pod adresem:
            <br />
            <br />
            Biuro Krajowej Rady Radiofonii i Telewizji
            <br />
            Skwer kard. S. Wyszyńskiego 9<br />
            01-015 Warszawa
            <br />
            Infolinia: 22 597 30 00
          </li>
        </ul>

        <h2>Komunikacja i dane kontaktowe</h2>
        <ul>
          <li>
            Dramox może wysyłać powiadomienia do Użytkownika pocztą elektroniczną (na adres wskazany przez Użytkownika
            podczas rejestracji) lub publikując informacje na Stronie.
          </li>
          <li>
            Użytkownik może skontaktować się z Dramox pod adresem Dramox s.r.o., Bucharova 2928/14a, Stodůlky, 158 00
            Praga 5, Aspira Business Centre, Czechy lub pocztą elektroniczną pod adresem{' '}
            <a href="mailto:sufler@dramox.pl">sufler@dramox.pl</a>.
          </li>
        </ul>
      </>
    );
  }, []);

  const getTerms = useCallback(() => {
    switch (locale) {
      case 'cs':
        return csTerms();
      case 'uk':
        return ukTerms();
      case 'pl':
        return plTerms();
      default:
        return enTerms();
    }
  }, [locale, csTerms, enTerms, ukTerms, plTerms]);

  return (
    <Layout countryCode={countryCode} hiddenWrappers={hideHeaderAndFooter} allowPopups={false}>
      <Head>{basicSEO(t('seo:terms_conditions_title'), t('seo:terms_conditions_description'))}</Head>
      <main className={[styles.legal, hideLinks ? styles.hideLinks : null].join(' ')}>{getTerms()}</main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { countryCode } = await authorizeUserServerSide(ctx);
  const forceLocale = (ctx.query?.locale as string) ?? null;

  return { props: { countryCode, forceLocale } };
}

export default TermsAndCondtions;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/terms-and-conditions/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  